import React, {useContext} from "react";

import Address from "./Address";

import {ContractsContext, Web3Context} from "../../contexts/Context";

import Math from "../utils/Math";

const Account = () => {
  const web3Context = useContext(Web3Context);
  const contractsContext = useContext(ContractsContext);

  const {activeAccount} = web3Context;
  const {balanceERC20, symbolERC20, decimalsERC20} = contractsContext;

  if (!activeAccount || !balanceERC20) {
    return null;
  }

  return (
    <div className="nav-link ml-3 d-flex align-items-center">
      <Address address={activeAccount}/>
      <span className="ml-1">({Math.formatDecimals(balanceERC20, decimalsERC20)} {symbolERC20})</span>
    </div>
  )
};

export default Account;